import { configureStore } from "@reduxjs/toolkit";
import { reducer as formReducer } from "redux-form";
import { createEpicMiddleware } from "redux-observable";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";

import audioReducer from "./audio/slice";
import audioCutCheckReducer from "./audioCutCheck/slice";
import ayrshareUserReducer from "./ayrshareUser/slice";
import bumperReducer from "./bumper/slice";
import categoryReducer from "./category/slice";
import categoryConfigurationReducer from "./categoryConfiguration/slice";
import centraliseStorageReducer from "./centraliseStorage/slice";
import ingestionReducer from "./changeStatusForAPIIngestion/slice";
import channelSummaryReducer from "./channelSummary/slice";
import clientReducer from "./client/slice";
import clipReducer from "./clip/slice";
import clipListReducer from "./clipList/slice";
import clipVideosListReducer from "./clipVideosList/slice";
import commonReducer from "./common/slice";
import contentReducer from "./content/slice";
import contentIngestionReducer from "./contentIngestion/slice";
import coreClipReducer from "./core/clip/slice";
import contentImageReducer from "./core/contentImage/slice";
import coreContentTagsReducer from "./core/contentTags/slice";
import contentVariantReducer from "./core/contentVariant/slice";
import coreFieldsReducer from "./core/fields/slice";
import highlightConfigReducer from "./core/highlightConfig/slice";
import notificationsReducer from "./core/notifications/slice";
import coreStorageReducer from "./core/storage/slice";
import subtitleTemplatesReducer from "./core/subtitleTemplates/slice";
import coreTagsReducer from "./core/tags/slice";
import thumbnailTemplatesReducer from "./core/thumbnailTemplates/slice";
import coreTournamentConfigReducer from "./core/tournamentConfig/slice";
import typesenseReducer from "./core/typesense/slice";
import typesensePublishesReducer from "./core/typesensePublishes/slice";
import countryReducer from "./country/slice";
import datafeedReducer from "./dataFeed/slice";
import dynamicTemplateVariableReducer from "./dynamicTemplateVariable/slice";
import entityReducer from "./entity/slice";
import featureListReducer from "./featureList/slice";
import fieldsReducer from "./fields/slice";
import filmstripReducer from "./filmstrip/slice";
import ftpListReducer from "./ftpList/slice";
import graphicsReducer from "./graphics/slice";
import illustoProjectReducer from "./illustoProject/slice";
import keyManagementReducer from "./keyManagement/slice";
import loggerReducer from "./logger/slice";
import markerTemplateReducer from "./markerTemplate/slice";
import matchScheduleReducer from "./matchSchedule/slice";
import mediaLiveOutputTemplateReducer from "./mediaLiveOutputTemplate/slice";
import newsChannelReducer from "./newsChannel/slice";
import newsShowsReducer from "./newsShows/slice";
import organizationReducer from "./organization/slice";
import organizationConfigReducer from "./organizationConfig/slice";
import overlayReducer from "./overlay/slice";
import planReducer from "./plans/slice";
import publishReducer from "./publish/slice";
import clientWebhookReducer from "./publisher/clientWebhook/slice";
import ftpPublishReducer from "./publisher/ftpPublish/slice";
import imagenReducer from "./publisher/imagen/slice";
import publishingTemplatesReducer from "./publishingTemplates/slice";
import reservedChannelReducer from "./reservedChannel/slice";
import roleReducer from "./role/slice";
import ruleConfigurationReducer from "./ruleConfiguration/slice";
import ruleExecutionReducer from "./ruleExecution/slice";
import ruleOutputsReducer from "./ruleOutputs/slice";
import serverReducer from "./server/slice";
import settingReducer from "./setting/slice";
import showReducer from "./shows/slice";
import socialProfileReducer from "./socialProfile/slice";
import srtSecretsReducer from "./srtSecrets/slice";
import storageReducer from "./storage/slice";
import streamReducer from "./stream/slice";
import streamPointerReducer from "./streamPointer/slice";
import streamTemplateReducer from "./streamTemplate/slice";
import studioProjectsReducer from "./studioProjects/slice";
import tagReducer from "./tag/slice";
import teamReducer from "./team/slice";
import templatesReducer from "./template/slice";
import templateConfigReducer from "./templateConfig/slice";
import tournamentReducer from "./tournament/slice";
import userReducer from "./user/slice";
import videoConversionTemplateReducer from "./videoConversionTemplate/slice";
import webStoryReducer from "./webStory/slice";
import webStoryTemplatesReducer from "./webStoryTemplates/slice";
import workspaceReducer from "./workspace/slice";
import workspaceConfigReducer from "./workspaceConfig/slice";
import xmlFormatsReducer from "./xmlFormats/slice";
import youtubeReducer from "./youtube/slice";

const epicMiddleware = createEpicMiddleware();
const middleware = [thunk, promise, epicMiddleware];

const rootReducer = {
  form: formReducer,
  common: commonReducer,
  markerTemplate: markerTemplateReducer,
  user: userReducer,
  featureList: featureListReducer,
  organization: organizationReducer,
  organizationConfig: organizationConfigReducer,
  workspace: workspaceReducer,
  workspaceConfig: workspaceConfigReducer,
  content: contentReducer,
  stream: streamReducer,
  clip: clipReducer,
  clipList: clipListReducer,
  audio: audioReducer,
  role: roleReducer,
  team: teamReducer,
  tournament: tournamentReducer,
  ruleConfiguration: ruleConfigurationReducer,
  ruleExecution: ruleExecutionReducer,
  ruleOutputs: ruleOutputsReducer,
  storage: storageReducer,
  bumpers: bumperReducer,
  datafeed: datafeedReducer,
  overlays: overlayReducer,
  graphics: graphicsReducer,
  setting: settingReducer,
  ftpList: ftpListReducer,
  entity: entityReducer,
  category: categoryReducer,
  logger: loggerReducer,
  illustoProject: illustoProjectReducer,
  tag: tagReducer,
  studioProjects: studioProjectsReducer,
  keyManagement: keyManagementReducer,
  xmlFormats: xmlFormatsReducer,
  srtSecrets: srtSecretsReducer,
  templates: templatesReducer,
  reservedChannels: reservedChannelReducer,
  server: serverReducer,
  client: clientReducer,
  centraliseStorage: centraliseStorageReducer,
  streamTemplate: streamTemplateReducer,
  templateConfig: templateConfigReducer,
  categoryConfiguration: categoryConfigurationReducer,
  webStoryTemplates: webStoryTemplatesReducer,
  channelSummary: channelSummaryReducer,
  mediaLiveOutputTemplate: mediaLiveOutputTemplateReducer,
  shows: showReducer,
  clipVideosList: clipVideosListReducer,
  videoConversionTemplate: videoConversionTemplateReducer,
  audioCutCheck: audioCutCheckReducer,
  streamPointer: streamPointerReducer,
  matchSchedule: matchScheduleReducer,
  webStory: webStoryReducer,
  ayrshareUser: ayrshareUserReducer,
  typesense: typesenseReducer,
  publish: publishReducer,
  socialProfile: socialProfileReducer,
  plans: planReducer,
  publishingTemplates: publishingTemplatesReducer,
  contentVariant: contentVariantReducer,
  contentImage: contentImageReducer,
  youtube: youtubeReducer,
  coreClip: coreClipReducer,
  ftpPublish: ftpPublishReducer,
  country: countryReducer,
  newsChannel: newsChannelReducer,
  thumbnailTemplates: thumbnailTemplatesReducer,
  dynamicTemplateVariable: dynamicTemplateVariableReducer,
  newsShows: newsShowsReducer,
  clientWebhook: clientWebhookReducer,
  coreStorage: coreStorageReducer,
  fields: fieldsReducer,
  subtitleTemplates: subtitleTemplatesReducer,
  notifications: notificationsReducer,
  ingestion: ingestionReducer,
  imagen: imagenReducer,
  coreField: coreFieldsReducer,
  coreTags: coreTagsReducer,
  coreContentTags: coreContentTagsReducer,
  filmstrip: filmstripReducer,
  coreTournamentConfig: coreTournamentConfigReducer,
  typesensePublishes: typesensePublishesReducer,
  contentIngestion: contentIngestionReducer,
  highlightConfig: highlightConfigReducer,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ["payload"],
      },
    }).concat(...middleware),
});

window.__store = store;

export default store;
